<template>
    <div class="justificacion-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="550">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">Gestión de las justificacion</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-alert
                            v-model="showErrorDataLoadedAlert"
                            type="error"
                            dismissible
                            transition="scale-transition"
                            dark
                        >
                            No se han podido cargar todos los datos necesarios para este formulario, intente cargar el
                            formulario nuevamente.
                        </v-alert>

                        <v-card-text>
                            <v-form ref="justificacionForm" v-model="validJustificacion">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                v-model="justificacion"
                                                :items="JUSTIFICACIONES"
                                                label="Justificación"
                                                hide-selected
                                                persistent-hint
                                                clearable
                                                item-text="descripcion"
                                                return-object
                                                placeholder="Seleccione la justificación..."
                                            >
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 sm12 v-if="justificacion">
                                            <v-chip>{{ justificacion.descripcion }}</v-chip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn flat icon color="success" @click="applyJustificacion">
                                                        <v-icon medium v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Utilizar justificación</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn flat icon color="orange" @click="modifyJustificacion">
                                                        <v-icon medium v-on="on">fa-edit</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Modificar justificación</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn flat icon color="red" @click="deleteItem">
                                                        <v-icon medium v-on="on">{{
                                                            deleteItemConfirm ? "fa-exclamation" : "fa-trash"
                                                        }}</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{
                                                    deleteItemConfirm ? "Confirmar acción" : "Eliminar justificación"
                                                }}</span>
                                            </v-tooltip>
                                        </v-flex>
                                        <v-flex xs12 sm9>
                                            <v-text-field
                                                v-model="justificacionItem.descripcion"
                                                :rules="descripcionFieldRules"
                                                :error-messages="descripcionFieldErrors"
                                                :counter="255"
                                                @keydown="descripcionFieldErrors = []"
                                                placeholder="O agrege una nueva..."
                                                append-icon="cancel"
                                                @click:append="cancelSaveAction"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm3>
                                            <v-btn
                                                flat
                                                color="success"
                                                :disabled="!validJustificacion"
                                                small
                                                @click="saveForm"
                                            >
                                                {{ modifiedJustificacion ? "Modificar" : "Agregar" }}
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :loading="loading">OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validJustificacion: false,
            justificacion: "",
            justificacionItem: {
                descripcion: ""
            },
            descripcionFieldRules: [
                v => !!v || "Debe proporcionar una descripción",
                v => (v && v.length <= 255) || "La descripción solo puede contener 255 caracteres"
            ],
            descripcionFieldErrors: [],

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false,

            //justificacion que va a ser modificacda
            modifiedJustificacion: null,

            //confirmar la eliminacion de un elemento
            deleteItemConfirm: false
        }
    },
    computed: {
        ...mapGetters(["JUSTIFICACIONES"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.justificacionForm.validate()
            if (this.validJustificacion) {
                var justificacion = {
                    descripcion: this.justificacionItem.descripcion
                }

                if (this.modifiedJustificacion) {
                    justificacion.id = this.modifiedJustificacion.id
                }

                this.$store
                    .dispatch(!this.modifiedJustificacion ? "ADD_JUSTIFICACION" : "UPDATE_JUSTIFICACION", justificacion)
                    .then(result => {
                        if (!result) {
                            //no hay coneccion con el servidor
                            this.loading = false
                        }
                        if (result === null || result.status === 404 || result.status === 500) {
                            //limpiar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                            this.justificacionItem.descripcion = ""
                            this.justificacion = ""
                        } else {
                            // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                            let { data, status } = result
                            if (status === 422) {
                                data.forEach(error => {
                                    if (error.field === "descripcion") {
                                        this.descripcionFieldErrors.push(error.message)
                                    }
                                })
                            }
                        }
                        this.loading = false
                    })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        modifyJustificacion() {
            this.modifiedJustificacion = this.justificacion
            this.justificacionItem.descripcion = this.modifiedJustificacion.descripcion
        },

        cancelSaveAction() {
            this.modifiedJustificacion = null
            this.justificacionItem.descripcion = null
            this.descripcionFieldErrors = []
        },

        deleteItem() {
            if (this.deleteItemConfirm) {
                this.loading = true
                this.$store.dispatch("DELETE_JUSTIFICACION", this.justificacion).then(() => {
                    this.deleteItemConfirm = false
                    this.justificacion = ""
                    this.loading = false
                })
            } else this.deleteItemConfirm = true
        },

        applyJustificacion() {
            let asistenciaJustificacion = {}
            asistenciaJustificacion.id = this.initialItem.id
            asistenciaJustificacion.justificacion_id = this.justificacion.id
            this.loading = true
            this.$store.dispatch("UPDATE_ASISTENCIA", asistenciaJustificacion).then(() => {
                this.loading = false
                this.cancelForm()
            })
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_JUSTIFICACIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
